import crud from './_crud'
import { callApi } from 'utils/api'
import { showErrorMessage, showSuccessMessage } from 'utils/messages'

const actions = crud(
	'bank_type',
	'Tipo de Banco',
	'Tipos de Bancos'
)

export default { ...actions, }
